/** Progressive enhancements exclusive to Panchita sections. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-panchita-scroll]');
  if (!link) return;
  const target = document.querySelector(link.getAttribute('href'));
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
});

document.querySelectorAll('[data-panchita-calculator]').forEach((calculator) => {
  const input = calculator.querySelector('input');
  const output = calculator.querySelector('[aria-live]');
  const coverage = Number(calculator.dataset.coverage);
  const waste = Number(calculator.dataset.waste) / 100;
  if (!input || !output || !Number.isFinite(coverage) || coverage <= 0) return;
  input.addEventListener('input', () => {
    const area = Number(input.value);
    output.textContent = area > 0
      ? `Estimated panels: ${Math.ceil((area * (1 + waste)) / coverage)} (includes ${Math.round(waste * 100)}% waste).`
      : `Enter an area to estimate panels, including ${Math.round(waste * 100)}% waste.`;
  });
});

document.querySelectorAll('[data-panchita-product-controls]').forEach((controls) => {
  const section = controls.closest('.panchita-products');
  const cards = [...section.querySelectorAll('[data-panchita-product-card]')];
  const search = controls.querySelector('[data-panchita-product-search]');
  const collection = controls.querySelector('[data-panchita-product-collection]');
  const empty = section.querySelector('[data-panchita-product-empty]');

  const updateProducts = () => {
    const term = search.value.trim().toLocaleLowerCase();
    let visible = 0;

    cards.forEach((card) => {
      const matchesTerm = !term || card.dataset.panchitaProductSearch.toLocaleLowerCase().includes(term);
      const matches = matchesTerm;
      card.hidden = !matches;
      if (matches) visible += 1;
    });

    empty.hidden = visible !== 0;
  };

  search.addEventListener('input', updateProducts);
  collection?.addEventListener('change', () => {
    if (collection.value) window.location.assign(collection.value);
  });
});

/**
 * The approved Panchita header is intentionally independent from Horizon's
 * markup. Keep its cart count in sync with the same Shopify cart event used by
 * Horizon after quantity changes, removals and quick add actions.
 */
const syncPanchitaCartCount = (itemCount) => {
  const count = Number(itemCount);
  if (!Number.isFinite(count) || count < 0) return;

  document.querySelectorAll('.panchita-header__cart').forEach((cartLink) => {
    const label = cartLink.dataset.cartLabel;
    if (label) cartLink.setAttribute('aria-label', `${label} (${count})`);

    const countElement = cartLink.querySelector('.panchita-header__cart-count');
    if (!countElement) return;

    countElement.textContent = count > 99 ? '99+' : String(count);
    countElement.hidden = count === 0;
  });
};

import('@shopify/events')
  .then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
      event.promise
        ?.then(({ cart, detail }) => {
          // `detail.itemCount` comes directly from Shopify's refreshed cart
          // section and is therefore the authoritative value for this update.
          syncPanchitaCartCount(detail?.itemCount ?? cart?.totalQuantity);
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[panchita-cart-count] Cart update failed:', error);
        });
    });
  })
  .catch((error) => console.warn('[panchita-cart-count] Cart event listener unavailable:', error));
